export default "__VITE_ASSET__RWacUA5c__"